import './App.css';
import ClientBooking from './pages/client-booking'

function App() {
  return (
    <div className="App">
      <ClientBooking/>
    </div>
  );
}

export default App;
